import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { BatchDownloadFileFilters } from './list/types';

export const initialValuesBatchDownloadFile: BatchDownloadFileFilters = {
  context: '',
  batchName: null,
  batchDescription: null,
  microserviceExecution: 'http://primami-operation-pratiche/primami-operation-pratiche',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageBatchDownloadFile = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesBatchDownloadFile}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageBatchDownloadFile.displayName = 'Page Download File initializer component';

export default PageBatchDownloadFile;
